import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {ParametersService, ZonesService} from "../../../core";
import {SimpleValveViewData} from "../../../models";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'simple-valve-info',
    templateUrl: './simple-valve-info.component.html',
    styleUrl: './simple-valve-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleValveInfoComponent implements OnInit {
    private parameters = inject(ParametersService);
    private $state = inject(StateService);
    private zonesService = inject(ZonesService);

    ngOnInit(): void {
        if (this.zonesService.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zonesService.setOverflow();
    }

    protected get selectedZone(): SimpleValveViewData {
        return this.zonesService.selectedZone as SimpleValveViewData;
    }

    protected get zoneName(): string {
        return this.zonesService.getZoneName(this.selectedZone);
    }

    protected get iconSrc(): string {
        return `/assets/img/zone_icons/light/${this.selectedZone?.description.styleIcon}.svg`;
    }

    protected get overflow(): boolean {
        return this.zonesService.overflow;
    }

    protected goBack(): void {
        this.zonesService.goBack();
    }
}
